import { useHeatmapSettingContext } from '@gem-sdk/heatmap-react';
import { EHeatmapLoadingKey, EHeatmapType } from '../types';
import { useHeatmapLoadingContext } from './view-context';
import { useMemo } from 'react';

export function useHeatmapDisableAction() {
  const heatmapType = useHeatmapSettingContext((s) => s.heatmapType);
  const isLoadingAuth = useHeatmapLoadingContext((s) => s.getLoadingByKey(EHeatmapLoadingKey.AUTH));
  const isLoadingAnalytic = useHeatmapLoadingContext((s) =>
    s.getLoadingByKey(EHeatmapLoadingKey.ANALYTICS),
  );
  const isLoadingClick = useHeatmapLoadingContext((s) =>
    s.getLoadingByKey(EHeatmapLoadingKey.CLICK_ELEMENT),
  );
  const isLoadingScroll = useHeatmapLoadingContext((s) =>
    s.getLoadingByKey(EHeatmapLoadingKey.HEATMAP_SCROLL),
  );
  const isLoadingSnapshotDom = useHeatmapLoadingContext((s) =>
    s.getLoadingByKey(EHeatmapLoadingKey.SNAPSHOT_DOM),
  );

  const isDisableAction = useMemo(() => {
    let isLoadingByHeatmapType = false;
    switch (heatmapType) {
      case EHeatmapType.Click:
        isLoadingByHeatmapType = isLoadingClick;
        break;
      case EHeatmapType.Scroll:
        isLoadingByHeatmapType = isLoadingScroll;
        break;
    }

    return isLoadingByHeatmapType || isLoadingAnalytic || isLoadingAuth || isLoadingSnapshotDom;
  }, [
    heatmapType,
    isLoadingAnalytic,
    isLoadingAuth,
    isLoadingSnapshotDom,
    isLoadingClick,
    isLoadingScroll,
  ]);

  const isDisableActionDeviceType = useMemo(
    () => isLoadingAnalytic || isLoadingSnapshotDom,
    [isLoadingAnalytic, isLoadingSnapshotDom],
  );

  return {
    isDisableAction,
    isDisableActionDeviceType,
  };
}
